import { TransportBrandItem } from '../bus/transportBrand/types';
import $axios from '../utils/axios-instance';

export default class TransportApi {
  async getTransportBrandList() {
    return await $axios
      .get<{ data: TransportBrandItem[] }>('/v1/transportModel')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getTransportBrandDetail(data: { id: number }) {
    return await $axios
      .get<TransportBrandItem>(`/v1/transportModel/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createTransportBrand(data: Omit<TransportBrandItem, 'id'>) {
    return await $axios
      .post('/v1/transportModel', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeTransportBrand(data: TransportBrandItem) {
    return await $axios
      .put(`/v1/transportModel/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteTransportBrand(data: { id: number }) {
    return await $axios
      .delete(`/v1/transportModel/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
